import CsvWebTokenizerRestService from './CsvWebTokenizerRestService'
import { TFunction } from "i18next"
import React from "react"
import { saveAs } from 'file-saver'

class CsvWebTokenizerService {
    static async loadTokenizedCsvFiles(setTokenizedCsvFiles: React.Dispatch<any>): Promise<any> {
        const tokenizedCsvFiles = await CsvWebTokenizerRestService.getTokenizedCsvFiles()
        setTokenizedCsvFiles(tokenizedCsvFiles)
    }

    static async protectCsvFile(csvConfig: any, t: TFunction, setTokenizedCsvFiles: React.Dispatch<any>) {
        try {
            const formData = new FormData()
            const file = csvConfig.csvFile
            formData.set('csvFile', file)
            formData.set('policy', csvConfig.policy)
            formData.set('delimiter', csvConfig.delimiter)
            formData.set('separator', csvConfig.dataSeparator)
            formData.set('fullValidationRequired', csvConfig.fullValidationRequired)
            const id = await CsvWebTokenizerRestService.protectCsvFile(formData)
            const response = await CsvWebTokenizerRestService.downloadCsvFile(id)
            if (setTokenizedCsvFiles) {
                const tokenizedCsvFiles = await CsvWebTokenizerRestService.getTokenizedCsvFiles()
                setTokenizedCsvFiles(tokenizedCsvFiles)
            }

            saveAs(response, 'TOK_' + file.name)

            return t('testdata.webtokenizer.protectsuccess', { name: file.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async unveilCsvFile(csvConfig: any, t: TFunction, setTokenizedCsvFiles: React.Dispatch<any>) {
        try {
            const formData = new FormData()
            const file = csvConfig.csvFile
            formData.set('csvFile', file)
            formData.set('policy', csvConfig.policy)
            formData.set('delimiter', csvConfig.delimiter)
            formData.set('separator', csvConfig.dataSeparator)
            formData.set('fullValidationRequired', csvConfig.fullValidationRequired)
            const id = await CsvWebTokenizerRestService.unveilCsvFile(formData)
            const response = await CsvWebTokenizerRestService.downloadCsvFile(id)
            if (setTokenizedCsvFiles) {
                const tokenizedCsvFiles = await CsvWebTokenizerRestService.getTokenizedCsvFiles()
                setTokenizedCsvFiles(tokenizedCsvFiles)
            }

            saveAs(response, 'DETOK_' + file.name)

            return t('testdata.webtokenizer.unveilsuccess', { name: file.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async deleteCsvFile(entry: any, t: TFunction, setTokenizedCsvFiles: React.Dispatch<any>): Promise<any> {
        try {
            await CsvWebTokenizerRestService.deleteCsvFile(entry.id)
            if (setTokenizedCsvFiles) {
                const tokenizedCsvFiles = await CsvWebTokenizerRestService.getTokenizedCsvFiles()
                setTokenizedCsvFiles(tokenizedCsvFiles)
            }
            return t('testdata.webtokenizer.deletesuccess', { name: entry.fileName })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async downloadCsvFile(entry: any) {
        const response = await CsvWebTokenizerRestService.downloadCsvFile(entry.id)
        if (entry.method === 'TOKENIZE') {
            saveAs(response, 'tokenized_' + entry.fileName)
        } else if (entry.method === 'DETOKENIZE') {
            saveAs(response, 'detokenized_' + entry.fileName)
        }
    }
}

export default CsvWebTokenizerService